import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxCaptchaModule } from "ngx-captcha";
import { ThemeModule } from "../@theme/theme.module";
import {
    NbAccordionModule,
    NbBadgeModule,
    NbButtonModule,
    NbCardModule,
    NbInputModule,
    NbProgressBarModule,
    NbRouteTabsetModule,
    NbTabsetModule,
} from "@nebular/theme";
import { CollectionsComponent } from "./collections.component";
import { CollectionsLayoutComponent } from "./collections.layout";
import { CollectionsRoutingModule } from "./collections.routing.module";
import { RecentTransactionComponent } from "./recent-transaction/recent-transaction.component";
import { ContributeComponent } from "./contribute/contribute.component";

@NgModule({
    declarations: [
        CollectionsComponent,
        CollectionsLayoutComponent,
        RecentTransactionComponent,
        ContributeComponent,
    ],
    imports: [
        CommonModule,
        ThemeModule,
        CollectionsRoutingModule,
        NbButtonModule,
        NbProgressBarModule,
        NbCardModule,
        NbBadgeModule,
        NbInputModule,
        FormsModule,
        ReactiveFormsModule,
        NgxCaptchaModule,
        NbRouteTabsetModule,
        NbTabsetModule,
        NbAccordionModule,
    ],
})
export class CollectionsModule {}
